import React from 'react';
import { HashLink } from 'react-router-hash-link';
import NavBar from '../components/Navbar/NavBar';
import heroImg1 from '../images/hero-img-1.svg';
import heroImg2 from '../images/hero-img-2.svg';
import heroImg3 from '../images/hero-img-3.png';

const Hero = () => {
    return (
        <>
            <div className="hero pt-24 pb-8 lg:pb-0" id='hero'>
                <div>
                    <NavBar />
                </div>

                <div className="m-auto overflow-hidden mt-8 lg:mt-4 h-5/6">
                    <div className="flex flex-col lg:flex-row justify-between text-center lg:text-left">
                        {/* Gambar di sebelah kiri */}
                        <img
                            alt="card img"
                            className="rounded-t absolute left-0"
                            style={{ paddingTop: "15%", width: "40%", maxWidth: "400px" }}
                            src={heroImg2}
                        />

                        {/* Konten teks di tengah */}
                        <div className="lg:w-1/2 flex flex-col justify-center relative pt-16 lg:pt-0" data-aos-delay="200">
                            <span className="badge mx-auto lg:mx-0 lg:ml-[15%] mb-5 w-fit">
                                Jasa Keamanan &amp; Cleaning Service
                            </span>

                            <h1 className="mb-5 md:text-5xl lg:text-6xl text-3xl font-bold leading-tight hero-title lg:pl-18">
                                Sistem Keamanan Terpercaya BSW
                            </h1>

                            <div className="text-lg md:text-xl tracking-tight mb-8 hero-description lg:pl-18">
                                PT Berani Setia Waspada adalah perusahaan yang
                                bergerak di bidang perdagangan umum dan jasa
                                keamanan (outsourcing), kami memiliki pengalaman
                                menangani masalah keamanan seperti perkantoran,
                                mall, perumahan, rumah sakit, perkebunan, pabrik,
                                pergudangan, dll
                            </div>

                            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center lg:justify-start lg:items-stretch lg:pl-[15%]">
                                <HashLink smooth to="/kontak" className="btn-primary">
                                    Hubungi Kami
                                </HashLink>
                                <HashLink
                                    smooth
                                    to="/layanan"
                                    className="btn border-2 border-brand text-brand hover:bg-brand hover:text-white focus-visible:ring-brand active:scale-[0.98]"
                                >
                                    Lihat Layanan
                                </HashLink>
                            </div>
                        </div>

                        {/* Gambar di sebelah kanan */}
                        <div className="flex lg:justify-end w-full lg:w-1/2 relative" data-aos-delay="700">
                            <div className="relative w-full">
                                <img
                                    alt="card img"
                                    className="rounded-t float-right duration-1000 w-full"
                                    src={heroImg1}
                                />
                                <img
                                    alt="card img"
                                    className="hero-img rounded-t float-right duration-1000 w-full absolute top-0 left-0 pl-8 lg:pl-18 m-20 filter brightness-80"
                                    src={heroImg3}
                                    style={{ width: "80%", maxWidth: "600px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Hero;
